var map = {
	"./add-contact-icon.svg": 14812,
	"./add-icon.svg": 18612,
	"./add-landing-icon.svg": 6266,
	"./alert-icon.svg": 18097,
	"./back-icon.svg": 95884,
	"./calendar-icon.svg": 60983,
	"./call-icon.svg": 49149,
	"./campaigns-running-icon.svg": 2524,
	"./connect-icon.svg": 37516,
	"./continue-icon.svg": 91053,
	"./create-campaign-icon.svg": 43675,
	"./crm-icon.svg": 2202,
	"./customer-icon.svg": 32068,
	"./dashboard-icon.svg": 78000,
	"./dashboard-subitem-icon.svg": 9164,
	"./date-icon.svg": 86164,
	"./delete-icon.svg": 6668,
	"./design-icon.svg": 10912,
	"./device-icon.svg": 2113,
	"./device-item-icon.svg": 17425,
	"./devices-icon.svg": 92774,
	"./download-qr-icon.svg": 48603,
	"./drop-down-icon.svg": 39800,
	"./dropdown-icon.svg": 65314,
	"./edit-campaign-icon.svg": 35275,
	"./edit-icon.svg": 44131,
	"./email-icon.svg": 48531,
	"./emails-icon.svg": 88849,
	"./facebook-icon.svg": 2374,
	"./finish-later-icon.svg": 77967,
	"./full-icon.svg": 96158,
	"./label-icon.svg": 63004,
	"./landing-page-icon.svg": 3395,
	"./linkedin-icon.svg": 82654,
	"./log-out-icon.svg": 95545,
	"./manage-campaign-icon.svg": 25584,
	"./manage-campaigns-icon.svg": 86831,
	"./marketing-icon.svg": 42502,
	"./network-icon.svg": 68503,
	"./new-email-icon.svg": 93965,
	"./open-rate-icon.svg": 78329,
	"./person-icon.svg": 97815,
	"./phone-icon.svg": 50934,
	"./plan-item-icon.svg": 85458,
	"./pm-delete-icon.svg": 21961,
	"./position-icon.svg": 70046,
	"./registration-drop-down-icon.svg": 84565,
	"./remove-icon.svg": 37370,
	"./remove-widget-icon.svg": 704,
	"./reports-icon.svg": 32623,
	"./retry-icon.svg": 99539,
	"./save-template-icon.svg": 19948,
	"./search-icon.svg": 62637,
	"./send-campaigns-icon.svg": 22735,
	"./send-email-icon.svg": 87402,
	"./send-icon.svg": 63971,
	"./send-test-email-icon.svg": 95807,
	"./settings-icon.svg": 55047,
	"./small-icon.svg": 83336,
	"./sms-contacts-icon.svg": 37636,
	"./sms-icon.svg": 98825,
	"./start-new-icon.svg": 34943,
	"./support-icon.svg": 24060,
	"./texts-failed-icon.svg": 52261,
	"./total-sent-icon.svg": 95212,
	"./total-sms-contacts-icon.svg": 52918,
	"./tt-icon.svg": 99623,
	"./twitter-icon.svg": 37436,
	"./unaro-full-icon.svg": 74402,
	"./upload-icon.svg": 60263,
	"./uploaded-file-icon.svg": 95741,
	"./users-icon.svg": 61649,
	"./verify-icon.svg": 32652,
	"./wifi-icon.svg": 79753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89169;